import { Components } from "@mui/material/styles";

export const MuiTab: Components['MuiTab'] = {
    styleOverrides: {
        root: {
            color: "#5A6872",
            letterSpacing: "0.23px",
            textAlign: "center",
            lineHeight: "24px",
            fontFamily: "Cairo SemiBold",
            boxSizing: 'border-box',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#0090D1',
                color: 'white',
            },
            '&.Mui-selected': {
                color: "#0090D1",
                backgroundColor: "#F2F5F8",
                borderBottom: '2px solid #0090D1'
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'pink',
            },
        }
    }
};
